"use client"

import { useState, useEffect } from "react"
import { BestsellersBlock } from "@/components/blocks/bestsellers"
import { RecentViewsBlock } from "@/components/blocks/recent-views"
import { ShopByBrandBlock } from "@/components/blocks/shop-by-brand"
import { getRecentlyViewed, getBestsellers } from "@/lib/recommendations"
import { fetchWithDelay } from "@/lib/api-fetch"

/**
 * Page-1-only client island for /collections/all: Shop-by-Brand, Bestsellers
 * and Recent Views. Carried over from the old client page so the tiered link
 * index itself stays server-rendered (plan §5 [A-17]).
 */
export function CollectionsAllExtras() {
  const [brands, setBrands] = useState<any[]>([])
  const [bestsellers, setBestsellers] = useState<any[]>([])
  const [recentViews, setRecentViews] = useState<any[]>([])

  useEffect(() => {
    async function fetchData() {
      // Safe fetch wrapper - returns empty/fallback on error
      const safeFetch = async <T,>(promise: Promise<T>, fallback: T): Promise<T> => {
        try {
          return await promise
        } catch {
          return fallback
        }
      }

      try {
        // Get bestsellers SITEWIDE (not collection-specific) - same as collection pages
        // Use fetchWithDelay to ensure BotID signals are collected before API calls
        const [brandsData, bestsellersData, recent] = await Promise.all([
          safeFetch(fetchWithDelay('/api/brands').then(res => res.ok ? res.json() : { brands: [] }), { brands: [] }),
          safeFetch(getBestsellers(6), []),
          safeFetch(getRecentlyViewed(6), [])
        ])
        setBrands(brandsData.brands || [])
        setBestsellers(bestsellersData)
        setRecentViews(recent)
      } catch {
        // Silently handle - data is optional for this page
        setBrands([])
        setBestsellers([])
        setRecentViews([])
      }
    }
    fetchData()
  }, [])

  return (
    <>
      {/* Shop by Brand - uses same component as collection pages with logos from Supabase */}
      {brands && brands.length > 0 && (
        <div className="mt-12 mb-12">
          <ShopByBrandBlock
            collectionName="All Products"
            collectionSlug="all"
            brands={brands.filter((b) => b.collection_href).slice(0, 12)}
          />
        </div>
      )}

      {/* Bestsellers on Fridge.com */}
      <div className="mt-12">
        <BestsellersBlock products={bestsellers} />
      </div>

      {/* Your Recent Views on Fridge.com */}
      <div className="mt-6 mb-12">
        <RecentViewsBlock products={recentViews} />
      </div>
    </>
  )
}
